import React from 'react'
import { useTranslation } from 'react-i18next'
import { useQuerySearchParams } from '@/hooks/use-query-search-params'
import { useSurveyForm } from '@/hooks/use-survey-form'
import { useCheckout } from '@/hooks/use-checkout'
import { SurveyFormTemplate } from '@/components/template/survey-form-template'
import { SurveyForm } from '@/components/organisms/survey/survey-form'
import { CheckoutReservationList } from '@/components/organisms/checkout/checkout-reservation-list'
import { useNavigate } from 'react-router-dom'
import { SurveyFormData } from '@/features/survey/survey-types'

/**
 * チェックアウトレビューページ
 * チェックアウトフロー内のアンケート回答ページ
 */
export const CheckoutReview = () => {
  const { t } = useTranslation()
  const { hotelId } = useQuerySearchParams<{ hotelId: string }>()
  const navigate = useNavigate()

  // チェックアウト処理用のフック
  const { handleCheckout, loadingCheckout } = useCheckout({
    hotelId,
  })

  // カスタムフックでアンケートフォームのロジックを管理
  const { useFormReturn, questions, handleSurveySubmit, loadingSurveyForm } = useSurveyForm({
    source: 'checkout',
    hotelId,
  })

  const { handleSubmit } = useFormReturn

  // 送信処理（チェックアウト → アンケート送信)
  const onSubmit = async (data: { answers: SurveyFormData }) => {
    // アンケート送信
    const result = await handleSurveySubmit(data)

    // アンケート回答成功時またはバリデーションエラー以外はチェックアウトを実行し、
    // チェックアウト完了ページへ遷移
    if (result?.success || result?.error !== 'validation_error') {
      await handleCheckout()
      navigate('/checkout/thanks')
    }
  }

  return (
    <SurveyFormTemplate
      title={t('Check-out')}
      loading={loadingCheckout || loadingSurveyForm}
      methods={useFormReturn}
      checkoutReservationList={<CheckoutReservationList hotelId={hotelId} />}
      // 質問がある場合のみフォームを表示
      form={<SurveyForm questions={questions} onSubmit={handleSubmit(onSubmit)} buttonText={t('Check-out')} />}
    />
  )
}
